module.exports = __webpack_public_path__ + "img/0919_03.bf425bbf.jpg";